import React from 'react';
import { Container } from './Container';
import { SectionHeading } from './SectionHeading';
import { steps } from '../data/content';
const stepStyles = [{
  badge: 'bg-brand',
  tile: 'bg-brandSoft'
}, {
  badge: 'bg-flame',
  tile: 'bg-flameSoft'
}, {
  badge: 'bg-goDark',
  tile: 'bg-goSoft'
}];
export function Mechanism() {
  return <section aria-labelledby="mechanism-heading" className="bg-paper pb-14 pt-4 sm:pb-20 sm:pt-8" data-id="element-113" data-mp="1w7c1jvhfke0c">
      <Container data-id="element-114" data-mp="ylogg6qfdi44">
        <SectionHeading id="mechanism-heading" title={<>
              From Your Printer to Playtime
              <span className="block" data-id="element-116" data-mp="18hrfh3pzd0mu">in 3 Simple Steps</span>
            </>} data-id="element-115" data-mp="yi0mx7kzcvpe" />

        <div className="mx-auto mt-10 max-w-[900px] sm:mt-14" data-id="element-117" data-mp="1d9hvnqblmim6">
          <ol className="grid grid-cols-3 overflow-hidden rounded-xl2 border border-hairline bg-white shadow-paper" data-id="element-118" data-mp="1db2n372m9lft">
            {steps.map((step, index) => {
            const style = stepStyles[index % stepStyles.length];
            return <li key={step.number} className={`flex flex-col items-center px-2 py-7 text-center sm:px-6 sm:py-10 ${index > 0 ? 'border-l border-dashed border-hairline' : ''}`} data-id="element-119" data-mp="pbkfunxrr4z4" data-mpi={index}>
                  <span aria-hidden="true" className={`flex h-14 w-14 items-center justify-center rounded-2xl text-[26px] sm:h-[68px] sm:w-[68px] sm:text-[32px] ${style.tile}`} data-id="element-120" data-mp="blh44qwimtnx">
                    {step.emoji}
                  </span>

                  <span className={`-mt-3 flex h-7 w-7 items-center justify-center rounded-full font-display text-[12px] font-extrabold tabular-nums text-white ring-[3px] ring-white sm:h-8 sm:w-8 sm:text-[13px] ${style.badge}`} data-id="element-121" data-mp="3st2mwt5pw7yh">
                    {index + 1}
                  </span>

                  <h3 className="mt-3.5 font-display text-[12px] font-extrabold uppercase leading-tight tracking-[0.05em] text-ink sm:mt-4 sm:text-[17px] sm:tracking-[0.08em]" data-id="element-122" data-mp="1n1ff50b97prs">
                    {step.title}
                  </h3>

                  <p className="mt-2 hidden text-[14px] font-semibold leading-[1.45] text-muted sm:block" data-id="element-123" data-mp="3lb4iv46b1p2n">
                    {step.description}
                  </p>
                </li>;
          })}
          </ol>

          <p className="mx-auto mt-7 max-w-[560px] text-center font-display text-[17px] font-extrabold leading-snug text-inkSoft sm:mt-9 sm:text-[20px]" data-id="element-124" data-mp="346vye0d612d">
            A flat sheet of paper goes in — a 3D toy they built themselves comes out.
          </p>
        </div>
      </Container>
    </section>;
}